import View from '../View';

/**
 * Anchor
 */
class Anchor extends View {
    /**
     * Anchor constructor
     * @param node
     */
    constructor(node) {
        super(node);

        //Check the url of this anchor seems to be external (http) and doesn't lead to npfo

        const hosts = [
          'knmp-npfo-website-2018.dev.dpdk.com',
          'npfo-o.knmp.local',
          'npfo-o.knmp.nl',
          'npfo-t.knmp.local',
          'npfo-t.knmp.nl',
          'npfo-a.knmp.local',
          'npfo-a.knmp.nl',
          'npfo-p.knmp.local',
          'test.npfo.nl',
          'test.npfo.local',
          'acceptance.npfo.local',
          'acceptance.npfo.nl',
          'www.npfo.nl',
          'www.npfo.local',
          'npfo.nl',
          'npfo.local'
        ];

        // console.log(this.node.hostname + this.node.href);

      if (!hosts.includes(this.node.hostname) &&
        !node.classList.contains('footer-logo-link') &&
        !node.classList.contains('exclude-external-link') &&
        this.node.hostname !== ""
      ) {
          //Set the target to _blank
          this.node.target = '_blank';
          this.node.rel = 'noopener';

          //Apply class for external link icon
          this.node.classList.add('external-link');
      }
    };
}

export default Anchor;



// WEBPACK FOOTER //
// frontend/js/components/Anchor.js